import gql from "graphql-tag";

export const hasWaybillImagesQuery = gql`
  query hasWaybillImages($routeId: Int!, $orderId: Int!, $waybillNum: String!) {
    hasWaybillImages(routeId: $routeId, orderId: $orderId, waybillNum: $waybillNum)
  }
`;
